import React, { useState } from "react";
import { Columns3, RotateCcw } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { humanize } from "./crudUtils";

export default function ColumnPicker({ options, selected, onChange, onReset }) {
  const [term, setTerm] = useState("");
  const shown = options.filter((f) => humanize(f).toLowerCase().includes(term.toLowerCase()));
  const toggle = (f) => onChange(selected.includes(f) ? selected.filter((x) => x !== f) : [...selected, f]);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-[#071b22] hover:border-[#165a71] transition-colors" data-testid="crud-columns-btn">
          <Columns3 className="h-4 w-4 text-[#165a71]" /> Columns
          <span className="rounded-full bg-[#165a71]/10 text-[#165a71] text-[11px] px-1.5">{selected.length}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 p-0 rounded-2xl" data-testid="crud-columns-popover">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
          <div className="text-sm font-semibold text-[#071b22]">Show columns</div>
          <button onClick={onReset} className="inline-flex items-center gap-1 text-xs text-[#165a71] hover:underline" data-testid="crud-columns-reset"><RotateCcw className="h-3 w-3" /> Reset</button>
        </div>
        <div className="px-3 pt-3"><input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Find a column…" className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:border-[#165a71]" data-testid="crud-columns-search" /></div>
        <div className="max-h-80 overflow-y-auto p-2">
          {shown.length === 0 && <div className="px-2 py-3 text-sm text-slate-400">No matching columns</div>}
          {shown.map((f) => (
            <label key={f} className="flex items-center gap-3 rounded-xl px-2 py-1.5 text-sm text-slate-700 hover:bg-slate-50 cursor-pointer">
              <Checkbox checked={selected.includes(f)} onCheckedChange={() => toggle(f)} data-testid={`crud-col-${f}`} />
              {humanize(f)}
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
